import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./login.css";

const Login = () => {
    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    // ================= VALIDATION =================
    const validate = () => {
        const e = {};
        if (!username.trim()) e.username = "Username is required";
        if (!password.trim()) e.password = "Password is required";
        setErrors(e);
        return Object.keys(e).length === 0;
    };

    // ================= LOGIN =================
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        try {
            setLoading(true);

            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ username, password })
            });

            const data = await res.json();

            if (data.success) {
                // ✅ STORE DATA
                localStorage.setItem("accessToken", data.accessToken);
                localStorage.setItem("refreshToken", data.refreshToken);
                localStorage.setItem("user", JSON.stringify(data.user));
                localStorage.setItem("role", data.user.role);

                // ✅ ROLE BASED NAVIGATION
                if (data.user.role === "admin") {
                    navigate("/admin");
                } else if (data.user.role === "editor") {
                    navigate("/editor");
                } else {
                    navigate("/user");
                }
            } else {
                setErrors({ general: data.message || "Invalid credentials" });
            }
        } catch (err) {
            setErrors({ general: "Server error. Please try again." });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="main-container">
            <div className="login-container">

                {/* LEFT PANEL */}
                <div className="left-panel">
                    <h1>Welcome Page</h1>
                    <p>Sign In To Your Account</p>
                </div>

                {/* RIGHT PANEL */}
                <div className="right-panel">
                    <h3>Hello !</h3>
                    <h2>Good Morning</h2>

                    <p className="login-text">
                        <span>Login</span> Your Account
                    </p>

                    {/* ERROR BOX */}
                    {errors.general && (
                        <div className="error-box">{errors.general}</div>
                    )}

                    <form onSubmit={handleSubmit}>

                        {/* USERNAME */}
                        <input
                            type="text"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => {
                                setUsername(e.target.value);
                                setErrors({ ...errors, username: "" });
                            }}
                            className={errors.username ? "input-error" : ""}
                        />
                        {errors.username && (
                            <div className="field-error">{errors.username}</div>
                        )}

                        {/* PASSWORD */}
                        <div className="password-field">
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="Password"
                                value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                    setErrors({ ...errors, password: "" });
                                }}
                                className={errors.password ? "input-error" : ""}
                            />

                            <span
                                className="eye-icon"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                        </div>
                        {errors.password && (
                            <div className="field-error">{errors.password}</div>
                        )}

                        <div className="options">
                            <span>Forgot Password?</span>
                        </div>

                        {/* BUTTON */}
                        <button type="submit" disabled={loading}>
                            {loading ? "Logging in..." : "Login"}
                        </button>
                    </form>

                </div>
            </div>
        </div>
    );
};

export default Login;